/* eslint-disable react/button-has-type */
import React, { useState } from 'react';

import { connect } from 'react-redux';
import { useHistory, useParams } from 'react-router-dom';
import { bindActionCreators } from 'redux';

import CommonAlert from 'components/CommonAlert/CommonAlert';
import ProductActive from 'images/icons/objects/boxesAndPackages/boxWhiteOutline.svg';
import ProductDisabled from 'images/icons/objects/boxesAndPackages/boxLightGrayOutline.svg';
import PrinterDisabled from 'images/icons/objects/printers/printerNavyGrayOutline.svg';
import PrinterActive from 'images/icons/objects/printers/printerWhiteOutline.svg';
import * as UserActions from 'store/actions/user';
import LabelPrintConfigDialog from 'modules/labelPrinting/pages/catalog/products/dialogs/LabelPrintConfigDialog';
import Environment from 'utils/environments';
import Axios from 'axios';

const environments = Environment(process.env.REACT_APP_ENV);

function FooterButton({ icon, label, onClick, className, styleImg }) {
  return (
    <button className="footer-button" onClick={onClick}>
      <div className="footer-img">
        <img src={icon} alt={`${label}Alt`} className={`${styleImg}`} />
      </div>
      <div className="footer-label-distance">
        <span className={`footer-label ${className}`}>{label}</span>
      </div>
    </button>
  );
}

function OverlayLabelPrintFooter({ userInfo }) {
  const history = useHistory();
  const { id: paramsID } = useParams();
  const profile = userInfo?.profile[0][0]?.name;
  const isAdminPage = profile === 'admin';
  const isLabelAdmin = profile === 'admin_label';
  const isLabelManager = profile === 'manager_label';
  const isLabelUser = profile === 'label';
  const [modalSettings, setModalSettings] = useState([
    {
      id: 1,
      name: 'labelPrintConfigDialog',
      open: false,
      product: null
    }
  ]);
  const isProductPage = history?.location?.pathname.includes('etiquetas/');
  const isLabelPrintDialogOpened = modalSettings?.find(
    (modal) => modal.name === 'labelPrintConfigDialog'
  ).open;
  const [message, setMessage] = useState({
    description: '',
    status: ''
  });

  const printLabel = async (product, isReprint = false) => {
    try {
      const response = await Axios.post(
        `${environments.catalog}/printer/products/labels`,
        {
          ...(isReprint && { labelId: product?.id }),
          restaurantId: paramsID,
          productId: isReprint ? product?.productId : product?.id,
          quantity: product?.quantity,
          numberOfLabels: product?.numberOfLabels,
          user: userInfo?.user
        },
        {
          headers: {
            'Content-Type': 'application/json'
          }
        }
      );

      setModalSettings(
        modalSettings.map((modal) =>
          modal.name === 'labelPrintConfigDialog'
            ? { ...modal, open: false, product: null }
            : modal
        )
      )

      setMessage({
        description: 'Solicitação de impressão enviada',
        status: 'success'
      });
      return response.data;
    } catch (error) {
      setMessage({
        description: 'Erro ao imprimir etiqueta',
        status: 'error'
      });
      throw error;
    }
  };

  return (
    <div className="overlay-footer">
      <FooterButton
        className={isProductPage ? 'bold footer-button-color-hover' : ''}
        icon={isProductPage ? ProductActive : ProductDisabled}
        label="Produtos"
        onClick={() => history.push(`/etiquetas/catalogo/produtos/${paramsID}`)}
      />

      <FooterButton
        className={
          isLabelPrintDialogOpened ? 'bold footer-button-color-hover' : ''
        }
        icon={isLabelPrintDialogOpened ? PrinterActive : PrinterDisabled}
        label="Impressão"
        onClick={() => {
          if (isLabelAdmin) return;
          
          setModalSettings(
            modalSettings.map((modal) =>
              modal.name === 'labelPrintConfigDialog'
                ? { ...modal, open: true }
                : modal
            )
          )
        }}
      />

      {modalSettings.find((modal) => modal.name === 'labelPrintConfigDialog')
        ?.open && (
        <LabelPrintConfigDialog
          open={
            modalSettings.find(
              (modal) => modal.name === 'labelPrintConfigDialog'
            )?.open
          }
          onClose={() => {
            setModalSettings(
              modalSettings.map((modal) =>
                modal.name === 'labelPrintConfigDialog'
                  ? { ...modal, open: false, product: null }
                  : modal
              )
            );
          }}
          onSubmit={(product, isReprint) => {
            printLabel(product, isReprint);
          }}
          userInfo={userInfo}
        />
      )}

      <CommonAlert
        open={message?.description}
        onClose={() => setMessage({ description: '', status: '' })}
        severity={message?.status}
        indexMessage={message?.description}
        messagePersonal={message?.description}
      />
    </div>
  );
}

const mapStateToProps = (state) => ({
  userInfo: state.user
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(UserActions, dispatch);

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(OverlayLabelPrintFooter);
